import React from 'react';
import cn from 'classnames';

type H1Props = {
  className?: string
}

export default function H1({className, children}: React.PropsWithChildren<H1Props>) {
  return (
    <h1 className={cn('text-4xl font-bold', className)}>{children}</h1>
  )
}
